import React from "react";
import { View } from "ui";

interface P {
  leftColumn?: React.ReactElement<any>;
  rightColumn?: React.ReactElement<any>;
  // active: "left" | "right";
}

export class AppColumns extends React.Component<P> {
  public render() {
    const { leftColumn, rightColumn } = this.props;
    const leftContainerProps = leftColumn
      ? {
        bg: "#e8e8e8"
      }
      : {};
    const rightContainerProps = {
      bg: rightColumn ? "#f7f7f7" : "#e8e8e8"
    };
    return (
      <View flex={1} flexDirection="row">
        <View
          pl={2}
          pt={4}
          pb={4}
          pr={2}
          flex={1}
          justifyContent="flex-start"
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          {...leftContainerProps}
        >
          {leftColumn}
        </View>
        <View
          flex={1}
          pl={2}
          pr={2}
          pt={4}
          pb={4}
          justifyContent="flex-start"
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          {...rightContainerProps}
        >
          {rightColumn}
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/main/components/AppColumns.tsx